module.exports = __webpack_public_path__ + "static/media/bigCommerce.f4a3b310.svg";